<template>
    <div>
        <div v-if="loadingDocumentTemplates">
            <div class="spinner"></div>
        </div>

        <div v-else-if="!documentTemplates.length" class="text-muted">
            <div class="text-center">{{$t('document_templates.table.no_document_templates')}}</div>
        </div>

        <div v-else>
            <ul class="list--clickable">
                <li v-for="template in documentTemplates" :key="template.id" @click="pick(template)">
                    {{ template.name }}
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import Pagination from '@/components/tables/Pagination';
    import {GET_DOCUMENT_TEMPLATES} from '@/store/modules/document-templates';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class DocumentTemplatesTable extends Vue {
        mounted() {
            this.$store.dispatch(GET_DOCUMENT_TEMPLATES, {});
        }

        get documentTemplates() {
            return this.$store.state.document_templates.templates;
        }

        get loadingDocumentTemplates() {
            return this.$store.state.document_templates.loading;
        }

        get documentTemplatesMeta() {
            return this.$store.state.document_templates.templatesMeta;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_DOCUMENT_TEMPLATES, {params: {page: pageNo}});
        }

        pick(template) {
            this.$emit('pick', {template});
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/DocumentTemplatesPickTable.vue